import React, { useState, createRef } from "react";
import styled from "styled-components";

import Auth from "../../service/auth";

import Button from "@material-ui/core/Button";
import { Row, Col, Text } from "../../comps";
import { Theme } from "../../theme/theme-provider";

const FormWrapper = styled(Col)`
  width: 40%;
  height: 100%;
  padding: 5%;
  color: #d7e0da;
  background: ${({ theme }) => theme.color.BLACK_1};
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.6);
  justify-content: space-between;
  align-items: center;
`;

const Head = styled(Col)`
  width: 100%;
`;

const InputWrapper = styled(Col)`
  width: 100%;
  flex-grow: 1;
  justify-content: space-around;
  margin-bottom: 30px;
  margin-top: 20px;
`;

const Input = styled.input`
  background: transparent;
  color: #d7e0da;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  outline: none;
  &:focus::placeholder {
    color: transparent;
    transition: opacity 2s;
  }
  &::placeholder {
    color: #d7e0da;
    opacity: 0.6;
    transition: opacity 2s;
  }
  &:-ms-input-placeholder {
    color: #d7e0da;
  }
  &::-ms-input-placeholder {
    color: #d7e0da;
  }
`;

export default ({ VIEW_TYPE, changeState, email }) => {
  const refOTP = createRef();

  const handleOTP = async () => {
    const otp = refOTP.current.value;
    const isOTPVerified = await Auth.verifyOTP({ email, otp });
    if (isOTPVerified) changeState(VIEW_TYPE.LOGIN);
  };

  return (
    <FormWrapper>
      <Head>
        <Text fontSize="14px" color="#d7e0da">
          {`Signup`}
        </Text>
        <Text
          marginTop="6px"
          fontSize="22px"
          color="#d7e0da"
        >{`Let's Get Started`}</Text>
      </Head>
      <InputWrapper>
        <Text
          marginTop="6px"
          fontSize="22px"
          color="#d7e0da"
        >{`Please enter the OTP sent to your E-Mail:${email}`}</Text>
        <Input type="text" placeholder="Please Enter OTP" ref={refOTP} />
      </InputWrapper>
      <Button
        style={{ backgroundColor: Theme.color.BLUE_5, width: "100%" }}
        variant="contained"
        color="primary"
        onClick={handleOTP}
      >
        {`Verify OTP`}
      </Button>
      <Row alignItems="center" marginTop="6px">
        <Text fontSize="14px" color="#d7e0da">
          {`Already have an account?`}
        </Text>
        <Button
          color="primary"
          onClick={() => {
            changeState(VIEW_TYPE.LOGIN);
          }}
        >
          {`LOGIN`}
        </Button>
      </Row>
    </FormWrapper>
  );
};
